Wee.fn.make('identoMap', {
	_construct: function() {
		this.accessToken = 'pk.eyJ1Ijoia2xlc3VlciIsImEiOiJjaW95cHd0d2UwMXo5dWNtOHNsYXc2ZXFpIn0.yODSFq1nX4hJXw9PWjwVFw';
		this.apiEndpoint = 'https://api.mapbox.com/geocoding/v5/mapbox.places/';
		this.mapboxAssetsEndpoint = 'https://api.mapbox.com/mapbox.js/v2.4.0/';

		$.view.addHelper({
			miles: function() {
				return Math.round(parseFloat(this.val) * 10) / 10;
			}
		});
	},
	init: function() {
		var scope = this;

		$('ref:footer').hide();

		$.screen.map([
			{
				max: 2,
				init: false,
				callback: function() {
					scope.unloadSearch();
					scope.unloadLocations();
					scope.unloadMap();
				},
				namespace: 'mapResize'
			},
			{
				max: 2,
				callback: function() {
					scope.initLocations();
					scope.initSearch();
				},
				namespace: 'mapResize'
			},
			{
				min: 3,
				init: false,
				callback: function() {
					scope.unloadSearch();
					scope.unloadLocations();
				},
				namespace: 'mapResize'
			},
			{
				min: 3,
				callback: function() {
					$.assets.load({
						js: [
							scope.mapboxAssetsEndpoint + 'mapbox.js',
							'/assets/js/lib/vendor/perfect-scrollbar.min.js'
						],
						css: [
							scope.mapboxAssetsEndpoint + 'mapbox.css',
							'/assets/css/lib/vendor/perfect-scrollbar.min.css'
						],
						success: function() {
							scope.initMap();
							scope.initLocations();
							scope.initSearch();
						}
					});
				},
				namespace: 'mapResize'
			}
		]);
	},
	unload: function() {
		$('ref:footer').show();

		$.screen.reset('mapResize');
	}
});